import SnapchatPixel from './SnapchatPixel';

export interface SnapchatData {
    [key: string]: string | number | undefined;
}

export interface SnapchatPurchaseDataShape extends SnapchatData {
    currency: string;
    price: number;
    transaction_id?: string;
}

export type SnapchatAdvancedMatchShape = {
    user_email?: string;
};

export default SnapchatPixel;
